import styled from '@emotion/styled';
import { getDefaultTextProps } from '../../styles.shared.ts';
import { EmotionTextProps } from '../../types.ts';

export const StyledText = styled.span<EmotionTextProps>`
  ${(props) => getDefaultTextProps(props)}
`;
